/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { EventsContext } from '@/data/context/events';
import { addToCartDelegator } from '@/data/events/delegators/AddToCart';
import { bannerClickDelegator } from '@/data/events/delegators/BannerClick';
import { bannerViewDelegator } from '@/data/events/delegators/BannerView';
import { cartPageViewDelegator } from '@/data/events/delegators/CartPageView';
import { cartViewDelegator } from '@/data/events/delegators/CartView';
import { checkoutDelegator } from '@/data/events/delegators/Checkout';
import { checkoutPageViewDelegator } from '@/data/events/delegators/CheckoutPageView';
import { checkoutPaymentDelegator } from '@/data/events/delegators/CheckoutPayment';
import { checkoutShippingDelegator } from '@/data/events/delegators/CheckoutShipping';
import { cookieDialogAcceptDelegator } from '@/data/events/delegators/CookieDialogAccept';
import { itemListViewDelegator } from '@/data/events/delegators/ItemListView';
import { carouselItemListViewDelegator } from '@/data/events/delegators/CarouselItemListView';
import { carouselProductClickDelegator } from '@/data/events/delegators/CarouselProductClick';
import { productClickDelegator } from '@/data/events/delegators/ProductClick';
import { productViewDelegator } from '@/data/events/delegators/ProductView';
import { promotionClickDelegator } from '@/data/events/delegators/PromotionClick';
import { promotionViewDelegator } from '@/data/events/delegators/PromotionView';
import { purchaseDelegator } from '@/data/events/delegators/Purchase';
import { removeFromCartDelegator } from '@/data/events/delegators/RemoveFromCart';
import { searchResultsViewDelegator } from '@/data/events/delegators/SearchResultsView';
import { signInDelegator } from '@/data/events/delegators/SignIn';
import { signUpDelegator } from '@/data/events/delegators/SignUp';
import { loginLessBeginDelegator } from '@/data/events/delegators/LoginLessBegin';
import { loginLessMethodDelegator } from '@/data/events/delegators/LoginLessMethod';
import { loginLessSubmitDelegator } from '@/data/events/delegators/LoginLessSubmit';
import { loginOpenDelegator } from '@/data/events/delegators/LoginOpen';
import { registerBeginDelegator } from '@/data/events/delegators/RegisterBegin';
import { passwordRecoveryBeginDelegator } from '@/data/events/delegators/PasswordRecoveryBegin';
import { passwordRecoveryCompleteDelegator } from '@/data/events/delegators/PasswordRecoveryComplete';
import { viewLookDelegator } from '@/data/events/delegators/ViewLook';
import { multiAddToCartDelegator } from '@/data/events/delegators/MultiAddToCart';
import { useContext, useEffect } from 'react';

export const useEventTracker = () => {
	const { registerEvent } = useContext(EventsContext);

	useEffect(() => {
		registerEvent('onPageView', () => {
			// do something
		});
		registerEvent('onAddToCart', addToCartDelegator);
		registerEvent('onProductView', productViewDelegator);
		registerEvent('onBannerView', bannerViewDelegator);
		registerEvent('onBannerClick', bannerClickDelegator);
		registerEvent('onCookieDialogAccept', cookieDialogAcceptDelegator);
		registerEvent('onSignUp', signUpDelegator);
		registerEvent('onSignIn', signInDelegator);
		registerEvent('onProductClick', productClickDelegator);
		registerEvent('onCheckout', checkoutDelegator);
		registerEvent('onCheckoutShipping', checkoutShippingDelegator);
		registerEvent('onCheckoutPayment', checkoutPaymentDelegator);
		registerEvent('onPromotionClick', promotionClickDelegator);
		registerEvent('onPromotionView', promotionViewDelegator);
		registerEvent('onSearchResultsView', searchResultsViewDelegator);
		registerEvent('onItemListView', itemListViewDelegator);
		registerEvent('onCarouselItemListView', carouselItemListViewDelegator);
		registerEvent('onCarouselProductClick', carouselProductClickDelegator);
		registerEvent('onCartView', cartViewDelegator);
		registerEvent('onCartPageView', cartPageViewDelegator);
		registerEvent('onRemoveFromCart', removeFromCartDelegator);
		registerEvent('onCheckoutPageView', checkoutPageViewDelegator);
		registerEvent('onPurchase', purchaseDelegator);
		registerEvent('onLoginLessBegin', loginLessBeginDelegator);
		registerEvent('onLoginLessMethod', loginLessMethodDelegator);
		registerEvent('onLoginLessSubmit', loginLessSubmitDelegator);
		registerEvent('onLoginOpen', loginOpenDelegator);
		registerEvent('onRegisterBegin', registerBeginDelegator);
		registerEvent('onPasswordRecoveryBegin', passwordRecoveryBeginDelegator);
		registerEvent('onPasswordRecoveryComplete', passwordRecoveryCompleteDelegator);
		registerEvent('onViewLook', viewLookDelegator);
		registerEvent('onMultiAddToCart', multiAddToCartDelegator);
	}, [registerEvent]);
	return {};
};
